import React from 'react';
import { useSubscription } from '../lib/hooks/useSubscription';
import { supabase } from '../lib/supabase';
import { Building2, Mail, Phone, LogOut } from 'lucide-react';

export function OrganizationArchivedModal() {
  const subscription = useSubscription();

  // Don't show while loading
  if (subscription.loading) {
    return null;
  }

  // Don't show if no organization
  if (!subscription.organization) {
    return null;
  }

  // Only show if organization is archived (active === false)
  if (subscription.organization.active !== false) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[9999] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden">
        {/* Header with gradient */}
        <div className="bg-gradient-to-r from-red-600 to-red-700 p-6 text-white text-center">
          <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Building2 className="w-8 h-8 text-white" />
          </div>

          <h2 className="text-2xl font-bold mb-2">
            Organizzazione Sospesa
          </h2>

          <p className="text-white/90">
            L'accesso al CRM è stato temporaneamente sospeso
          </p>
        </div>

        {/* Content */}
        <div className="p-6 bg-white">
          <div className="space-y-4 mb-4">
            <p className="text-gray-800 text-center font-medium">
              La tua organizzazione è stata disattivata. Per riattivare l'accesso al CRM, contatta l'assistenza.
            </p>

            <div className="bg-gray-100 rounded-lg p-4">
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-red-600 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900">
                    Email
                  </p>
                  <a
                    href="mailto:assistenza@flusia.it"
                    className="text-red-600 hover:text-red-700 hover:underline font-medium"
                  >
                    assistenza@flusia.it
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-gray-100 rounded-lg p-4">
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-red-600 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900">
                    Telefono
                  </p>
                  <a
                    href="tel:+39XXXXXXXXXX"
                    className="text-red-600 hover:text-red-700 hover:underline font-medium"
                  >
                    Contatta l'assistenza
                  </a>
                </div>
              </div>
            </div>

            <button
              onClick={() => supabase.auth.signOut({ scope: 'local' })}
              className="w-full flex items-center justify-center gap-2 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-3 px-4 rounded-lg transition-colors"
            >
              <LogOut className="w-4 h-4" />
              Esci dall'account
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-100 px-6 py-4 border-t border-gray-200">
          <p className="text-sm text-gray-700 text-center">
            I tuoi dati sono al sicuro. Una volta riattivata l'organizzazione potrai accedere nuovamente.
          </p>
        </div>
      </div>
    </div>
  );
}
